'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Carousel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _list = require('../list');

require('./carousel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Carousel Component.
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */

// components
function Carousel(props) {
    var _cx;

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$fade = props.fade,
        fade = _props$fade === undefined ? '' : _props$fade;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-carousel': true
    }, (0, _defineProperty3.default)(_cx, 'sb-carousel--fade-' + fade, fade), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('section', {
        className: classNames,
        id: id
    }, void 0, (0, _jsx3.default)(_list.List, {
        className: 'sb-carousel__inner'
    }, void 0, props.children));
}
// css
//# sourceMappingURL=Carousel.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/carousel/Carousel.js
// module id = 552
// module chunks = 0